module.exports = Aegis;